<template>
	<div class="bottom">
		<footer class="footer bg-style">
			<div class="footer-upper full">
				<div class="container">
					<div class="sec-title text-center">
						<h2>联系我们</h2>
						<p>期待与您携手，共同并进，共创辉煌</p>
						<span class="decor"><span class="inner"></span></span>
					</div>
					<div class="row">
						<div class="col-md-3 col-sm-6">
							<div class="footer-widget about-widget">
								<a href="#">
									<img src="../../assets/img/resources/footer-logo.png"/>
								</a>
								<p class="company-cnname">{{systemInfo.company_name_cn}}</p>
								<p class="company-enname">{{systemInfo.company_name_en}}</p>
								<ul class="contact full">
									<li><i class="fa fa-map-marker"></i> <span>{{systemInfo.company_address_cn}}</span></li>
									<li><i class="fa fa-phone"></i> <span>{{systemInfo.company_mobile}}</span></li>
									<li><i class="fa fa-envelope-o"></i> <span>{{systemInfo.company_email}}</span></li>
								</ul>
							</div>
						</div>
						<div class="col-md-4 latest-post col-sm-6 col-md-offset-1">
							<div class="footer-widget latest-post news-post">
								<h3 class="title">公司新闻</h3>
								<ul>
									<li v-for="item in bestNews.slice(0,3)" @click="detail(item)">
										<span class="border"><img v-lazy="item.news_img" alt="" style="width:87px;height: 65px;"></span>
										<div class="content">
											<a href="javascript:void();">{{item.news_title}}</a>
											<span>{{item.created.full.split(" ")[0]}}</span>
										</div>
									</li>
								</ul>
							</div>
						</div>
						<div class="col-md-4 col-sm-6">
							<div class="footer-widget contact-widget">
								<h3 class="title">在线留言</h3>
								<form action="" class="contact-form" id="footer-cf">
									<input type="text" name="message_name" placeholder="请填写您的真实姓名">
									<input type="email" name="message_email" placeholder="请填写您的电子邮箱">
									<textarea name="message_content" placeholder="请填写您的留言内容"></textarea>
									<button type="submit">确认发送</button>
								</form>
							</div>
						</div>
					</div>
				</div>
			</div>
			<div class="footer-bottom">
				<div class="container text-center">
					<p>Copyright &copy; 2018 {{systemInfo.company_name_en}} All rights reserved. <a href="https://beian.miit.gov.cn/" target="_blank">{{systemInfo.icp_code}}</a></p>
				</div>
			</div>
		</footer>
	</div>
</template>

<script>
	import { mapActions, mapGetters } from 'vuex';
	import { Message } from 'iview';
	import Server from "@/assets/js/servers.js";
	export default {
		name: "page-footer",
		data(){
			return{
			}
		},
		created(){
			this.init(()=>{
				// console.log('load');
			});
		},
		mounted(){
			this.initForm();
		},
		watch:{
			linkList(n){
				var that = this;
				that.$nextTick(()=>{
					that.initSiteMap();
				});
			}
		},
		computed:{
			...mapGetters(['linkList','bestNews','systemInfo'])
		},
		methods:{
			initSiteMap(){
				$('.sponsors-section .slider').owlCarousel({
		            loop: true,
		            margin: 20,
		            nav: true,
		            autoplay: 5000,
		            responsive: {
		                0: {
		                    items: 1
		                },
		                600: {
		                    items: 2
		                },
		                800: {
		                    items: 3
		                },
		                1024: {
		                    items: 4
		                },
		                1100: {
		                    items: 5
		                }
		            }
		        });
			},
			initForm(){
				let that = this;
	            $('#footer-cf').validate({ // initialize the plugin
	                rules: {
	                    'message_name': {
	                        required: true
	                    },
	                    'message_email': {
	                        required: true,
	                        email: true
	                    },
	                    'message_content': {
	                        required: true
	                    }
	                },
	                submitHandler: function(form) {
	                    that.$http.post(Server.create_memo+"?"+$(form).serialize()).then(res=>{
							if(res.code == 0){
								that.$Message.success("提交成功");
								$(form).find('input[type="text"]').val('');
							    $(form).find('input[type="email"]').val('');
							    $(form).find('textarea').val('');
							}else{
								that.$Message.error("提交失败");
							}
						}).catch(e=>{
							that.$Message.error("提交失败");
						});
	                    return false;
	                }
	            });
			},
			detail(item){
				// let href = window.location.href.split("#")[0];
				// href += "#/newsDetail/"+ item.id;
				// window.open(href);
				this.$router.push({
					name: 'newsDetail',
					params: {
						id: item.id
					}
				});
			},
			...mapActions(['init'])
		},
		components:{
			Message
		}
	}
</script>

<style>

</style>



// WEBPACK FOOTER //
// src/components/common/PageFooterElse.vue